/**
 * Post-login redirect target sanitizer (AIR-564).
 *
 * `?redirect=` is attacker-influenceable (anyone can send a crafted login
 * link), so only same-origin relative paths are honored. Everything else —
 * absolute URLs, protocol-relative URLs, and backslash variants — returns
 * null and the caller falls back to the role-based landing page.
 *
 * The backslash cases matter: the WHATWG URL parser treats `\` as `/` in
 * special-scheme URLs, so `/\evil.com` and `\/evil.com` navigate exactly
 * like `//evil.com` (protocol-relative → off-origin) in every browser.
 */
export function sanitizeRedirectPath(raw: string | null | undefined): string | null {
  if (!raw) return null;
  if (!raw.startsWith("/")) return null;
  // Reject "//host", "/\host" — anything whose second char re-opens an
  // authority section once backslashes normalize to slashes.
  const second = raw[1];
  if (second === "/" || second === "\\") return null;
  return raw;
}
